import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import About from "./components/About";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Products from "./components/Products";
import Contact from "./components/Contact";

import "./styles/style.css";
import Map from "./components/Map";
import Footer from "./components/Footer";
import FloatingWhatsapp from "./components/FloatingWhatsapp";

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      {/* <Stats /> */}
      <About />
      <Services />
      <WhyChooseUs />
      <Products />
      <Contact />
      {/* <Map /> */}
      <Footer />
      <FloatingWhatsapp />
    </>
  );
}

export default App;